import DeleteResourceInteractor from "../../core/interactor/app/crud/DeleteResourceInteractor";
import Constants from "../common/Constants";

export default class DeleteLegalViewInteractor {
  private resource: DeleteResourceInteractor;

  constructor({ deleteResource }: any) {
    this.resource = deleteResource;
  }

  async execute(legalViewId: number) {
    return this.resource.execute(Constants.endpointBasePath, legalViewId);
  }
}
